/*
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2022-09-03 11:47:17
 * @LastEditTime: 2024-11-07 15:49:18
 */
let secondCross = '' // 本地调试如有跨域问题则赋值，若上线则把cross置空，并改http.js里的域名 /secondApi
let timestamp = Date.parse(new Date()) / 1000;

const commonAPI = {
  // 图片上传接口
  uploadPictures: {
    method: 'post',
    url: '/fileStorage/uploadFileMobile'
  },
  // 批量上传
  batchUploadFile: {
    method: 'post',
    url: '/fileStorage/batchUploadFileMobile'
  },
  // 批量上传-返回预览id
  batchUploadFileId: {
    method: 'post',
    url: `/fileStorage/batchUploadFileIdMobile?n=${timestamp}`
  },
  // 登录 （手机）
  phoneLogin: {
    method: 'post',
    url: '/uncheck/phoneLogin'
  },
  // 登录-加密 （手机）
  phoneLoginNew: {
    method: 'post',
    url: '/uncheck/phoneLoginNew'
  },
  // 获取密钥
  getEncryptKey: {
    method: 'get',
    url: '/uncheck/getEncryptKey'
  },
  // 手机端获取当前登录司机信息
  getDriverInfo: {
    method: 'get',
    url: '/uncheck/getDriverInfo',
    mask: false // 判断是否需要加载loading框
  },
  // 修改默认密码
  updateDefPwd: {
    method: 'post',
    url: '/system/profile/updateDefPwd'
  },
  // 修改默认密码-加密
  updateDefPwdNew: {
    method: 'post',
    url: '/system/profile/updateDefPwdNew'
  },
  getSysIp: {
    method: 'get',
    url: '/system/config/getConfigByKey?configKey=sys.app.url.tel',
    mask: false // 判断是否需要加载loading框

  },
  getVedioPath: {
    method: 'get',
    url: '/system/config/getConfigByKey?configKey=driver.operation.video'
  },
  // 登出
  logout: {
    method: 'post',
    url: '/uncheck/logout',
  },
  setNewPassword: {
    method: 'post',
    url: '/logistics/driver/setNewPassword',
  },
  setNewPasswordNew: {
    method: 'post',
    url: '/logistics/driver/setNewPasswordNew',
  },
  remind: {
    method: 'post',
    url: '/logistics/transportOrder/driver/remind'
  },
  // 饲料安全责任书
  getFeedAgreement: {
    method: 'get',
    url: '/system/config/getConfigByKey?configKey=feed.biosafety.commitment'
  },
  // 生猪安全责任书
  getPigAgreement: {
    method: 'get',
    url: '/system/config/getConfigByKey?configKey=pig.biosafety.commitment'
  },
  // 司机安全确认
  safetyConfirm: {
    method: 'post',
    url: '/logistics/driver/safety/confirm'
  },
  // 猪类型
  getPigType: {
    method: 'get',
    url: '/system/dict/data/getDictByType?dictType=goods_type_pig'
  },
  // 饲料类型
  getFeedType: {
    method: 'get',
    url: '/system/dict/data/getDictByType?dictType=goods_type_feed'
  },
  // 货物数量阈值
  goodsQuantityRatio: {
    method: 'get',
    url: '/system/config/getConfigByKey?configKey=loadingpoint.quantity.ratio'
  },
  // 消息提醒
  notificationReminder: {
    method: 'get',
    url: '/logistics/transportOrder/driver/notificationReminder'
  },
  // 数据字典
  getDictData: {
    method: 'get',
    url: '/system/dict/data/getDictByType'
  },
  // 数据暂存
  saveMobileDataTemp: {
    method: 'post',
    url: '/system/config/saveMobileDataTemp',
    mask: true // 判断是否需要加载loading框
  },
  // 数据暂存查询
  queryMobileDataTemp: {
    method: 'post',
    url: '/system/config/queryMobileDataTemp',
    mask: false // 判断是否需要加载loading框

  },
  // 数据暂存删除
  deleteMobileDataTemp: {
    method: 'post',
    url: '/system/config/deleteMobileDataTemp',
    mask: true // 判断是否需要加载loading框
  },
  //gps消息通知
  noticeList: {
    method: 'get',
    url: '/logistics/notice/list',
    mask: true // 判断是否需要加载loading框
  },
  //提醒已读
  readInfo: {
    method: 'post',
    url: '/logistics/notice/readInfo',
    mask: true // 判断是否需要加载loading框
  },
  //切换角色
  updateRouteType: {
    method: 'post',
    url: '/system/user/updateRouteType',
    mask: true // 判断是否需要加载loading框
  },
  //获取参数签名
  getSignParam: {
    method: 'get',
    url: '/logistics/wechat/getSignParam',
    mask: true // 判断是否需要加载loading框
  },
  //获取参数签名
  getSign: {
    method: 'post',
    url: '/logistics/wechat/getSign',
    mask: true // 判断是否需要加载loading框
  },
  //上报gps地点
  uploadCarLocation: {
    method: 'post',
    url: '/logistics/car/uploadCarLocation',
  },
  // 经纬度转地址
  getLocationAddress: {
    method: 'get',
    url: '/logistics/tencentLocation/getLocationAddress',
  },
  //通知
  breedingRegionList: {
    method: 'get',
    url: '/logistics/bizParam/list',
  },
  // 定位上报
  getUploadTimes: {
    method: 'get',
    url: '/system/config/getConfigByKey?configKey=driver.location.upload.times',
    mask: false // 判断是否需要加载loading框

  },
  // 签收人登录
  receiverLogin: {
    method: 'post',
    url: '/uncheck/receiverLoginNew',
    // url: '/uncheck/receiverLogin',
    mask: false // 判断是否需要加载loading框
  },
  // 技术员登录
  chargePersonLogin: {
    method: 'post',
    url: '/uncheck/chargePersonLoginNew',
    // url: '/uncheck/chargePersonLogin',
    mask: false // 判断是否需要加载loading框
  },
  // 身份切换
  switchLogin: {
    method: 'post',
    url: '/uncheck/switchLogin',
    mask: false // 判断是否需要加载loading框
  },
  //签收人-签收订单
  receiverSign: {
    method: 'post',
    url: '/logistics/transportOrder/receiver/receiverSign',
    mask: false // 判断是否需要加载loading框
  },


};

export default commonAPI;



// WEBPACK FOOTER //
// ./src/api/common.js